import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

// Catalogue média partagé : accessible à tout utilisateur connecté (accès filtré par dossier).
export const MediaCatalogRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route index element={<Index />} />
  </SubRouter>
))
